const GY = "data:image/svg+xml,%3c?xml%20version='1.0'%20encoding='utf-8'?%3e%3csvg%20version='1.1'%20xmlns='http://www.w3.org/2000/svg'%20viewBox='0%200%20900%20600'%3e%3cpath%20fill='%23009E49'%20d='M0,0h900v600H0V0z'/%3e%3cpath%20fill='%23FFFFFF'%20d='M0,0l947,300L0,600V0z'/%3e%3cpath%20fill='%23FFD00D'%20d='M0,26.1L870,300L0,573.9V26.1z'/%3e%3cpath%20fill='%232D2D2D'%20d='M0,0l450,300L0,600V0z'/%3e%3cpath%20fill='%23D3132F'%20d='M0,35l397.5,265L0,565V35z'/%3e%3c/svg%3e";
export {
  GY as default
};
//# sourceMappingURL=GY.svg.es.js.map
